import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Mentions Légales</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Éditeur du site</h2>
            <div className="text-gray-700 space-y-2">
              <p><strong>Raison sociale :</strong> OPTIMHUB</p>
              <p><strong>Forme juridique :</strong> Société par actions simplifiée (SAS)</p>
              <p><strong>Capital social :</strong> 5 001,00 €</p>
              <p><strong>Siège social :</strong> 11 Rue de Lourmel, 75015 Paris, France</p>
              <p><strong>SIREN :</strong> 534 057 088</p>
              <p><strong>SIRET :</strong> 534 057 088 00039</p>
              <p><strong>Numéro de TVA intracommunautaire :</strong> FR63534057088</p>
              <p><strong>RCS :</strong> Paris</p>
              <p><strong>Code APE/NAF :</strong> 7021Z - Conseil en relations publiques et communication</p>
              <p><strong>Président :</strong> BOSS CORP</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Directeur de la publication</h2>
            <p className="text-gray-700">Le directeur de la publication est le représentant légal de la société OPTIMHUB.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Hébergement</h2>
            <div className="text-gray-700 space-y-2">
              <p>Le site 123pariez.com est hébergé par :</p>
              <p><strong>Emergent</strong></p>
              <p>Service d'hébergement cloud</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Propriété intellectuelle</h2>
            <p className="text-gray-700">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels, etc.) 
              est protégé par le droit d'auteur et le droit des marques. Toute reproduction, représentation, 
              modification, publication, adaptation de tout ou partie des éléments du site, quel que soit 
              le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de OPTIMHUB.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Limitation de responsabilité</h2>
            <p className="text-gray-700">
              123pariez.com est un site comparateur d'offres de paris sportifs. Les informations présentes 
              sur ce site sont fournies à titre indicatif et peuvent être modifiées à tout moment par les 
              opérateurs de paris. OPTIMHUB ne saurait être tenu responsable des éventuelles différences 
              entre les informations affichées sur ce site et celles proposées par les opérateurs.
            </p>
            <p className="text-gray-700 mt-4">
              Les paris sportifs comportent des risques de perte financière. Jouez de manière responsable. 
              Les jeux d'argent sont interdits aux mineurs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Liens hypertextes</h2>
            <p className="text-gray-700">
              Ce site contient des liens hypertextes vers des sites d'opérateurs de paris sportifs agréés 
              par l'ANJ (Autorité Nationale des Jeux). Ces liens sont fournis à titre informatif. OPTIMHUB 
              n'est pas responsable du contenu de ces sites externes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Droit applicable</h2>
            <p className="text-gray-700">
              Les présentes mentions légales sont régies par le droit français. En cas de litige, 
              les tribunaux français seront seuls compétents.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Contact</h2>
            <p className="text-gray-700">
              Pour toute question concernant ce site, vous pouvez nous contacter à l'adresse du siège social 
              mentionnée ci-dessus.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
